//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
import "../no/ExternalFileReferenceAdapter.js";
let d=[[],[[["referenceObjectId"],"GetExternalFileReferenceAdapter",{R_:{adapter:"ExternalFileReferenceAdapter"}},1,0],[["referenceObjectId","adapter"],"SetExternalFileReferenceAdapter",{},2,0],[["adapter"],"GetExternalFileDefinitionKey",{R_:{externalFileDefinitionKey:''}},1,0],[["referenceObjectId","referenceType","externalFileSpec"],"EstablishReference",{R_:{adapter:"ExternalFileReferenceAdapter"}},3,0]],[]];
SPLM.Motion.AnalyticalContactBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.AnalyticalContactBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.AnalyticalContactBuilder.ContactTypeOption = Object.freeze({
    "SphereToSphere" : "SphereToSphere", "SphereToExtrusion" : "SphereToExtrusion", "SphereToRevolution" : "SphereToRevolution", "ExtrusionToRevolution" : "ExtrusionToRevolution", "RevolutionToRevolution" : "RevolutionToRevolution", "SphereToRail" : "SphereToRail", "SphereToFlexible" : "SphereToFlexible", "FlexibleToFlexible" : "FlexibleToFlexible"});

SPLM.Motion.AnalyticalContactBuilder.ProfileType = Object.freeze({
    "None" : "None", "Circular" : "Circular", "Road" : "Road"});

SPLM.Motion.AnalyticalContactBuilder.SearchMethodType = Object.freeze({
    "Fast" : "Fast", "Robust" : "Robust"});

SPLM.Motion.AnalyticalContactBuilder.ReferenceObjectId = Object.freeze({
    "ExtrusionGeometryDataFile" : "ExtrusionGeometryDataFile", "RevolutionGeometryDataFile" : "RevolutionGeometryDataFile", "SecondRevolutionGeometryDataFile" : "SecondRevolutionGeometryDataFile", "RailGeometryDataFile" : "RailGeometryDataFile"});

SPLM.Motion.AnalyticalContactBuilder.RailDefinitionType = Object.freeze({
    "Rail" : "Rail", "Function" : "Function", "Profile" : "Profile"});

export default SPLM;